import React from 'react';
import './AutoBundlerProgress.scss';
import { AutoBundlerProgressReport } from '../../utils/bundlingService';

const progressBarColors = [
  '#81D0D9',
  '#73C4CD',
  '#66B8C2',
  '#59ACB7',
  '#4CA0AC',
  '#3F94A0',
  '#328895',
  '#257C8A',
  '#18707F',
  '#0B6574',
];

function progressBarColor(percentage: number): string {
  if (percentage >= 100) {
    return progressBarColors[progressBarColors.length - 1];
  }
  return progressBarColors[
    Math.floor((percentage / 100) * progressBarColors.length)
  ];
}

export default function AutoBundlerProgress({
  autoBundlerProgress,
}: {
  autoBundlerProgress: AutoBundlerProgressReport;
}): JSX.Element {
  return (
    <div className="auto-bundler-status-container">
      {autoBundlerProgress.progress === 0 && (
        <span>Auto bundling starting...</span>
      )}
      {autoBundlerProgress.progress === 100 && (
        <span>Auto bundling completed!</span>
      )}
      {autoBundlerProgress.progress > 0 &&
        autoBundlerProgress.progress < 100 && (
          <span>
            Auto bundling &mdash; {Math.floor(autoBundlerProgress.progress)}%{' '}
          </span>
        )}
      <div className="auto-bundler-status__progress-bar-wrapper">
        <div className="auto-bundler-status__progress-bar">
          <div
            className="auto-bundler-status__progress-bar-fill"
            style={{
              width: `${autoBundlerProgress.progress}%`,
            }}
          >
            <span
              className="auto-bundler-status__progress-bar-fill_animate auto-bundler-status__progress-bar-fill_progress"
              style={{
                backgroundColor: progressBarColor(autoBundlerProgress.progress),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
